import { useState } from 'react';
import axiosInstance from '../../interceptor/axiosInstance';
import { ApiRoutes } from './../../routes/routeConstants/apiRoutes';
import { deserialize } from 'serializr';
import { DemoVideStatus, DemoVideo } from 'models/DemoVideo/demoVideo.model';
import { DemoVideoTypes } from 'enums/demoVideoEnums';

const DemoVideoService = () => {
  const [loading, setLoading] = useState<boolean>(false);

  const [demoWatchedStatus, setDemoWatchedStatus] = useState<DemoVideStatus>();

  const [demoVideos, setDemoVideos] = useState<DemoVideo[]>([]);

  const fetchDemoVideoLink = async () => {
    try {
      setLoading(true);
      const res = await axiosInstance.get(ApiRoutes.GET_DEMO_VIDEO_LINK);
      const demoVideos = deserialize(
        DemoVideo,
        res.data['demo_videos']
      ) as DemoVideo[];
      setDemoVideos(demoVideos);
      return demoVideos;
    } catch (error) {
    } finally {
      setLoading(false);
    }
  };

  const fetchDemoWatchStatus = async () => {
    try {
      setLoading(true);
      const res = await axiosInstance.get(
        ApiRoutes.GET_DEMO_VIDEO_WATCH_STATUS
      );
      const statusData = deserialize(DemoVideStatus, res.data);
      setDemoWatchedStatus(statusData);
    } catch (error) {
    } finally {
      setLoading(false);
    }
  };

  const updateDemoWatchStatus = async (type: DemoVideoTypes) => {
    try {
      setLoading(true);
      await axiosInstance.put(ApiRoutes.GET_DEMO_VIDEO_WATCH_STATUS, { type });
    } catch (error) {
    } finally {
      setLoading(false);
    }
  };

  return {
    loading,
    demoVideos,
    fetchDemoVideoLink,
    fetchDemoWatchStatus,
    demoWatchedStatus,
    updateDemoWatchStatus,
  };
};

export default DemoVideoService;
